module.exports = __webpack_public_path__ + "2e4f2df558d563665454e0dff7cff3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/abhinav-rastogi.jpg
// module id = 654
// module chunks = 0